import { AdminBlockResponse } from "../contracts/AdminBlockResponse";

/** Frontend model for one admin overview row, with parsed dates. */
export interface AdminUser {
  instructorId: string;
  userAccountId: string | null;
  firstName: string;
  lastName: string;
  email: string;
  signupDate: Date;
  instructorStatus: string;
  organizationRole: string;
  teamInstructorCount: number;
  memberCount: number;
  sessionCount: number;
  contractCount: number;
  visitCount: number;
  lastActiveAt: Date | null;
  hasSubscription: boolean;
  subscriptionState: string | null;
  trialEndsAt: Date | null;
  trialDaysRemaining: number | null;
  isFoundingMember: boolean;
  hasProviderSubscription: boolean;
  complimentaryUntil: Date | null;
  customMonthlyAmountMinorUnits: number | null;
  customAnnualAmountMinorUnits: number | null;
  customPriceCurrency: string | null;
  /** The platform's active block on the account (US-111); null when not blocked. */
  block: AdminBlockResponse | null;
  isDemo: boolean;
}

/** Full display name, falling back to the email local-part when no name is set. */
export const adminUserDisplayName = (user: AdminUser): string => {
  const name = `${user.firstName} ${user.lastName}`.trim();
  return name.length > 0 ? name : user.email;
};
